import React from "react";
import "./Pagination.css";
import DropDown from "../DropDown/DropDown";
import { GrFormNext } from "react-icons/gr";
import { MdNavigateBefore } from "react-icons/md";
import PropTypes from "prop-types";
import { useDispatch, useSelector } from "react-redux";
import { fetchFilteredTableDataInit } from "../../../redux/slices/operationHomeSlice";

const Pagination = ({
  totalPage,
  currentPage,
  limit,
  paginateHandler,
  setPageSize,
  totalData,
  tableStartIndex,
  tableEndIndex,
  showRowsPerPage = true,
}) => {
  const dispatch = useDispatch();

  const activeTab = useSelector((state) => state.operationHome.activeTab);
  const startDate = useSelector((state) => state.operationHome.tabStartDate);
  const endDate = useSelector((state) => state.operationHome.tabEndDate);
  const pageSize = useSelector((state) => state.operationHome.table.pageSize);
  const searchFields = useSelector((state) => state.operationHome.searchFields);

  // ✅ Page Change
  const paginate = (pageNumbers) => {
    if (pageNumbers > totalPage || pageNumbers <= 0) return;

    paginateHandler && paginateHandler(pageNumbers);
  };

  // ✅ Page Size Change
  const pageSelect = (pagePerPost) => {

    setPageSize && setPageSize(pagePerPost);
  };

  const lastPage = totalPage === 0 ? 1 : totalPage;

  // ✅ FIXED DISPLAY TEXT LOGIC
  const start = tableStartIndex ?? 0;
  const end = tableEndIndex ?? 0;
  const total = totalData ?? 0;

  const displayText =
    start === end
      ? `${start} of ${total}`       // single item page (Agent screen)
      : `${start}-${end} of ${total}`; // table pagination

  return (
    <div className="Pagination" id="pagination">
      <nav aria-label="Page navigation example">
        <ul className="pagination justify-content-end m-0 align-items-center">

          {/* ✅ Rows Per Page (OPTIONAL) */}
          {showRowsPerPage && (
            <>
              <li className="page-item page-item-text">
                <span style={{ fontSize: "12px" }}>Rows Per Page</span>
              </li>

              <li className="page-item mx-1">
                <DropDown
                  className="pagination-input--dropdown"
                  inputHandler={(e) => pageSelect(e)}
                  options={[5, 10, 20, 50, 100]}
                />
              </li>
            </>
          )}

          {/* ✅ Entry Count Display */}
          <li className="page-item page-item-text">
            <span>{displayText}</span>
          </li>

          {/* ✅ Previous Button */}
          <li className="page-item">
            <button
              className="page-item--icon"
              onClick={() => paginate(currentPage - 1)}
              disabled={currentPage === 1 || !currentPage}
            >
              <MdNavigateBefore />
            </button>
          </li>

          {/* ✅ Next Button */}
          <li className="page-item">
            <button
              className="page-item--icon"
              onClick={() => paginate(currentPage + 1)}
              disabled={currentPage === lastPage || !currentPage}
            >
              <GrFormNext />
            </button>
          </li>

        </ul>
      </nav>
    </div>
  );
};

Pagination.propTypes = {
  totalPage: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  currentPage: PropTypes.number,
  limit: PropTypes.number,
  paginateHandler: PropTypes.func,
  setPageSize: PropTypes.func,
  totalData: PropTypes.number,
  tableStartIndex: PropTypes.number,
  tableEndIndex: PropTypes.number,
  showRowsPerPage: PropTypes.bool,
};

export default Pagination;